/* eslint-disable no-magic-numbers */
import classNames from 'classnames';
import React from 'react';
import { getRowHeightSize } from '../../user-grid-settings/user-grid-settings-actions';
import { UserGridSettingsContext } from '../../user-grid-settings/user-grid-settings-context';
import { nestedAccountHeightOverride } from '../style-rows';
import { HeadingRow } from '../types';
import { MARGIN_LEFT_LEVEL } from './header-row-utils';
import grid from '../../../../../ui/data-grid/components/grid.scss';
import { PredictionsAccountCategories, VIEW_TYPES } from '../../../../../core/types';

interface Props {
  isLast?: boolean;
  level: number;
  row: HeadingRow;
  wrapperStyle: React.CSSProperties;
  category?: PredictionsAccountCategories;
  viewType?: VIEW_TYPES;
}

export const HeaderRowHeading: React.FC<Props> = React.memo(({ row, level, wrapperStyle }) => {
  const { rowHeights } = React.useContext(UserGridSettingsContext);
  const rowHeight = getRowHeightSize(rowHeights);

  const assumptionsRowHeightOverride = nestedAccountHeightOverride(row, rowHeight, level);

  const headerRowClasses = classNames({
    [grid.rowHeader]: true,
    [grid.rowHeading]: true,
    [grid.isBold]: true
  });

  const headerRowInnerClasses = classNames({
    [grid.rowHeaderInner]: true,
    [grid[assumptionsRowHeightOverride]]: true
  });

  return (
    <div className={headerRowClasses} style={wrapperStyle} role="row">
      <div
        className={headerRowInnerClasses}
        style={{
          backgroundColor: row.headerBackground || '#cac9cd',
          marginLeft: level * MARGIN_LEFT_LEVEL
        }}
        role="cell"
      >
        <div className={classNames(grid.flexContainer, grid.flexContainerJustify)}>
          <div className={grid.title} data-testid="account-name">
            {row.account.name}
          </div>
        </div>
      </div>
    </div>
  );
});
